var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMemberCardFront(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 46,
    viewBox: "0 0 72 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "member_card_front",
    transform: "translate(-24 -40.04)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3284",
    "data-name": "Group 3284",
    transform: "translate(24 40)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3283",
    "data-name": "Group 3283"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2117",
    "data-name": "Rectangle 2117",
    width: 72,
    height: 46,
    rx: 10,
    transform: "translate(0 0.04)",
    fill: "#e5edf8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11363",
    "data-name": "Path 11363",
    d: "M307.6,80h7.2a3.6,3.6,0,0,1,3.6,3.6v3.6H307.6a3.6,3.6,0,1,1,0-7.2Z",
    transform: "translate(-253.6 -72.8)",
    fill: "#fafdff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3285",
    "data-name": "Group 3285",
    transform: "translate(29.76 47.2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11365",
    "data-name": "Path 11365",
    d: "M56,216h7.2v2.88H56Z",
    transform: "translate(-56 -191.52)",
    fill: "#fafdff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11366",
    "data-name": "Path 11366",
    d: "M112,216h15.84v2.88H112Z",
    transform: "translate(-101.92 -191.52)",
    fill: "#fafdff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11367",
    "data-name": "Path 11367",
    d: "M56,248h2.88v2.88H56Z",
    transform: "translate(-56 -217.76)",
    fill: "#fafdff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11368",
    "data-name": "Path 11368",
    d: "M88,248h2.88v2.88H88Z",
    transform: "translate(-82.24 -217.76)",
    fill: "#fafdff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11369",
    "data-name": "Path 11369",
    d: "M120,248h2.88v2.88H120Z",
    transform: "translate(-108.48 -217.76)",
    fill: "#fafdff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11370",
    "data-name": "Path 11370",
    d: "M152,248h2.88v2.88H152Z",
    transform: "translate(-134.72 -217.76)",
    fill: "#fafdff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11371",
    "data-name": "Path 11371",
    d: "M184,248h2.88v2.88H184Z",
    transform: "translate(-160.96 -217.76)",
    fill: "#fafdff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11372",
    "data-name": "Path 11372",
    d: "M216,248h2.88v2.88H216Z",
    transform: "translate(-187.2 -217.76)",
    fill: "#fafdff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11373",
    "data-name": "Path 11373",
    d: "M344,144h8.64v2.88H344Z",
    transform: "translate(-292.16 -132.48)",
    fill: "#fafdff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11374",
    "data-name": "Path 11374",
    d: "M296,144h5.76v2.88H296Z",
    transform: "translate(-252.8 -132.48)",
    fill: "#fafdff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11375",
    "data-name": "Path 11375",
    d: "M84.16,87.2h-7.2V80H71.2v7.2H64v5.76h7.2v7.2h5.76v-7.2h7.2Z",
    transform: "translate(-62.56 -80)",
    fill: "#fafdff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMemberCardFront);
export default __webpack_public_path__ + "static/media/member_card_front.4d28e3f518a016220c8a9ea623186389.svg";
export { ForwardRef as ReactComponent };